import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Container from 'common/Container';
import { useTheme } from '@material-ui/core/styles';

const Hero = ({ themeMode = 'light' }) => {
  const theme = useTheme();

  return (
    <Box>
      <Box marginBottom={2}>
        <Container
          sx={{
            backgroundImage:
              themeMode === 'dark'
                ? 'url(/images/logos/logo_white.PNG)'
                : 'url(/images/logos/logo_tnonetwork_black.png)',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            backgroundSize: 'contain',
            height: '16vh',
          }}
        />
        <Typography
          sx={{ textTransform: 'uppercase', fontWeight: 600 }}
          variant="overline"
          color="textSecondary"
          align="center"
          display="block"
          gutterBottom
        >
          Propuesta Comercial
        </Typography>
        <Box
          component={Typography}
          fontWeight={700}
          variant="h3"
          gutterBottom
          align="center"
          color={theme.palette.primary.main}
        >
          Movistar & TNO Network
        </Box>
        <Typography
          variant="h6"
          component="p"
          color="textSecondary"
          align="center"
          sx={{ fontStyle: 'italic', mb: 3 }}
        >
          Conectividad con Propósito: El Aliado Tecnológico de la Esperanza
        </Typography>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            mb: 3,
          }}
        >
          <Box
            component="img"
            src="/images/logos/movistar.webp"
            alt="Movistar"
            sx={{
              width: 120,
              height: 120,
              objectFit: 'contain',
            }}
          />
        </Box>
        <Box
          sx={{
            maxWidth: 720,
            mx: 'auto',
            py: 2,
            px: 2,
            borderRadius: 2,
            bgcolor: theme.palette.mode === 'dark' ? 'action.hover' : 'grey.50',
          }}
        >
          <Typography
            variant="h6"
            component="p"
            color="textSecondary"
            align="center"
            gutterBottom
          >
            <strong>Análisis de Oportunidad</strong>
          </Typography>
          <Typography variant="body1" color="textSecondary" align="center">
            Para que la integración de <strong>Movistar</strong> en <strong>Punto de Fe</strong> tenga la misma jerarquía y solidez que la de un aliado estratégico, tratamos a la marca no como un anunciante, sino como el <strong>Aliado Tecnológico de la Esperanza</strong>. El mensaje de fe viaja gracias a la infraestructura de Movistar; la conectividad con propósito convierte a la marca en el dueño de la red de fe en Venezuela.
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

Hero.propTypes = {
  themeMode: PropTypes.string,
};

export default Hero;
